import React from "react";
import logo from "../../assets/images/Newsletter/images/cslogo1.png";
import bgHeader from "../../assets/images/Newsletter/images/bg-header.png";
import banner from "../../assets/images/Newsletter/banners/aug-2022.webp";
import sagar from "../../assets/images/Newsletter/images/sagar.jpg";
import Airoplan from "../../assets/images/Newsletter/April-2023/airoplan.jpg";
import Graph from "../../assets/images/Newsletter/April-2023/graph.jpg";
import Bank from "../../assets/images/Newsletter/April-2023/bank.jpg";
import Wonder5 from "../../assets/images/Newsletter/April-2023/wondeal5.jpg";
import Wonder6 from "../../assets/images/Newsletter/April-2023/wondeal6.jpg";
import Wonder7 from "../../assets/images/Newsletter/April-2023/wondeal7.jpg";
import Testimonial1 from "../../assets/images/Newsletter/April-2023/testimonial1.jpg";
import Testimonial2 from "../../assets/images/Newsletter/April-2023/testimonial2.jpg";
import Impact from "../../assets/images/Newsletter/April-2023/impact1.jpg";
import News3 from "../../assets/images/Newsletter/April-2023/news3.jpg";
import Andy from "../../assets/images/Newsletter/April-2023/andy.png";
import EmployeeAwards1 from "../../assets/images/Newsletter/April-2023/empaward1.jpg";
import EmployeeAwards2 from "../../assets/images/Newsletter/April-2023/empaward2.jpg";
import Birthday1 from "../../assets/images/Newsletter/April-2023/birthday1.jpg";
import Birthday2 from "../../assets/images/Newsletter/April-2023/birthday2.jpg";
import Welcome from "../../assets/images/Newsletter/April-2023/welcome.jpg";
import Motivation from "../../assets/images/Newsletter/April-2023/motivation.jpg";
import fb1 from "../../assets/images/Newsletter/images/fb1.png";
import tw1 from "../../assets/images/Newsletter/images/tw1.png";
import ln1 from "../../assets/images/Newsletter/images/ln1.png";
import ig1 from "../../assets/images/Newsletter/images/ig1.png";
import yt1 from "../../assets/images/Newsletter/images/yt1.png";
import BusinessQuoteOne from "../../assets/images/Newsletter/images/Business-quote-1.jpg";
import Building from "../../assets/images/Newsletter/April-2023/bg-header.png";
const August2022 = () => {
  return (
    <>
      <>
        <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
        {/*[if !mso]><!*/}
        <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
        {/*<![endif]*/}
        <meta name="viewport" content="width=device-width,initial-scale=1" />
        <title>COMSENSE - NEWSLETTER April-2025</title>
        <link
          rel="shortcut icon"
          href="https://www.comsenseconsulting.com/images/ico/favicon.ico"
        />
        <style
          dangerouslySetInnerHTML={{
            __html:
              "\n    @import url(https://fonts.googleapis.com/css2?family=Cookie&display=swap);\n    @import url(https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500&display=swap);\n\n    @import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap');\n\n    @font-face {\n      font-family: 'Century Gothic', sans-serif;\n      src: url(fonts/CenturyGothic.ttf);\n    }\n\n    html {\n      font-family: century-gothic, sans-serif;\n      font-family: \"Montserrat\", sans-serif;\n    }\n\n    .ReadMsgBody {\n      width: 100%;\n      background-color: #fff\n    }\n\n    .ExternalClass {\n      width: 100%;\n      background-color: #fff\n    }\n\n    .ExternalClass,\n    .ExternalClass div,\n    .ExternalClass font,\n    .ExternalClass p,\n    .ExternalClass span,\n    .ExternalClass td {\n      line-height: 100%\n    }\n\n    html {\n      width: 100%\n    }\n\n    body {\n      -webkit-text-size-adjust: none;\n      -ms-text-size-adjust: none;\n      margin: 0;\n      padding: 0;\n      font-family: 'Open Sans', Arial, Sans-serif !important;\n      font-family: \"Montserrat\", sans-serif !important;\n    }\n\n    table {\n      border-spacing: 0;\n      table-layout: fixed;\n      margin: 0 auto\n    }\n\n    table table table {\n      table-layout: auto\n    }\n\n    img {\n      display: block !important;\n      overflow: hidden !important\n    }\n\n    .yshortcuts a {\n      border-bottom: none !important\n    }\n\n    img:hover {\n      opacity: .9 !important\n    }\n\n    a {\n      color: red;\n      text-decoration: none\n    }\n\n    .textbutton a {\n      font-family: 'open sans', arial, sans-serif !important;\n      font-family: \"Montserrat\", sans-serif;\n    }\n\n    .btn-link a {\n      color: #fff !important\n    }\n\n    ul {\n      padding-inline-start: 20px\n    }\n\n    ol {\n      padding-inline-start: 20px\n    }\n\n    .mobile-responsive {\n      display: none\n    }\n\n    .image-reponsive {\n      float: left;\n      margin-left: 0;\n      margin-right: 25px;\n      margin-top: 10px\n    }\n\n    @media only screen and (max-width:640px) {\n      body {\n        margin: 0;\n        width: auto !important;\n        font-family: 'Open Sans', Arial, Sans-serif !important\n      }\n\n      .table-inner {\n        width: 90% !important;\n        max-width: 90% !important\n      }\n\n      .table-full {\n        width: 100% !important;\n        max-width: 100% !important;\n        text-align: center !important\n      }\n\n      #sagar img {\n        width: 50%\n      }\n\n      .mobile-responsive {\n        display: block\n      }\n\n      .desktop-view {\n        display: none\n      }\n\n      .image-reponsive {\n        float: unset;\n        margin: 0 auto 10px\n      }\n\n      @media only screen and (max-width:479px) {\n        body {\n          width: auto !important;\n          font-family: 'Open Sans', Arial, Sans-serif !important\n        }\n\n        .table-inner {\n          width: 90% !important;\n          text-align: center !important\n        }\n\n        .table-full {\n          width: 100% !important;\n          max-width: 100% !important;\n          text-align: center !important\n        }\n\n        u+.body .full {\n          width: 100% !important;\n          width: 100vw !important\n        }\n\n        #sagar img {\n          width: 50%\n        }\n      }\n    }\n  ",
          }}
        />
        <table
          className="full newsletter-emailer"
          width="100%"
          alignitems="center"
          cellSpacing={0}
          cellPadding={0}
        >
          <tbody>
            <tr>
              <td
                bgcolor="#333742"
                background={bgHeader}
                style={{
                  borderTop: "4px solid red",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
                align="center"
              >
                <table
                  className="table-full"
                  width={600}
                  style={{ maxWidth: 600 }}
                  border={0}
                  align="center"
                  cellPadding={0}
                  cellSpacing={0}
                >
                  <tbody>
                    <tr>
                      <td
                        height={40}
                        valign="top"
                        style={{
                          fontFamily: "Open sans,arial,sans-serif",
                          fontSize: 10,
                          color: "#fff",
                          lineHeight: "24px",
                          textAlign: "center",
                        }}
                      >
                        If this newsletter is not displayed correctly, please{" "}
                        <a href="/" style={{ color: "#fff" }}>
                          <u>click here</u>
                        </a>
                        .
                      </td>
                    </tr>
                    <tr>
                      <td align="center">
                        <table
                          className="table-full"
                          align="centre"
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                        >
                          <tbody>
                            <tr>
                              <td align="center" style={{ lineHeight: 0 }}>
                                <img
                                  editable=""
                                  label="image"
                                  style={{
                                    display: "block",
                                    lineHeight: 0,
                                    fontSize: 0,
                                    border: 0,
                                  }}
                                  src={logo}
                                  width={160}
                                  alt="logo"
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td height={25} />
                    </tr>
                  </tbody>
                </table>
                <table
                  className="table-full"
                  width={600}
                  style={{ maxWidth: 600 }}
                  border={0}
                  align="center"
                  cellPadding={0}
                  cellSpacing={0}
                >
                  <tbody>
                    <tr>
                      <td>
                        <img
                          editable=""
                          label="image"
                          style={{
                            display: "block",
                            lineHeight: 0,
                            fontSize: 0,
                            border: 0,
                          }}
                          src={banner}
                          width="100%"
                          alt="logo"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
        <repeater>
          <table
            className="full"
            align="center"
            bgcolor="#333742"
            width="100%"
            border={0}
            cellSpacing={0}
            cellPadding={0}
          >
            <tbody>
              <tr>
                <td align="center">
                  <table
                    className="table-full"
                    width={600}
                    style={{ maxWidth: 600 }}
                    border={0}
                    align="center"
                    cellPadding={0}
                    cellSpacing={0}
                  >
                    <tbody>
                      <tr>
                        <td bgcolor="#FFFFFF" align="center">
                          <table
                            className="table-inner"
                            width={550}
                            border={0}
                            align="center"
                            cellPadding={0}
                            cellSpacing={0}
                          >
                            <tbody>
                              <tr>
                                <td height={20} />
                              </tr>
                              <tr>
                                <td>
                                  <table
                                    width={150}
                                    className="table-full"
                                    border={0}
                                    align="left"
                                    cellPadding={0}
                                    cellSpacing={0}
                                  >
                                    <tbody>
                                      <tr>
                                        <td
                                          id="sagar"
                                          align="center"
                                          style={{ lineHeight: 0 }}
                                        >
                                          <img
                                            src={sagar}
                                            alt="icon"
                                            style={{
                                              width: 167,
                                              display: "block",
                                              lineHeight: 0,
                                              fontSize: 0,
                                              border: 0,
                                            }}
                                          />
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  {/*[if (gte mso 9)|(IE)]>
                </td>
                <td>
                  <![endif]*/}
                                  <table
                                    width={25}
                                    align="left"
                                    border={0}
                                    cellPadding={0}
                                    cellSpacing={0}
                                  >
                                    <tbody>
                                      <tr>
                                        <td height={15} />
                                      </tr>
                                    </tbody>
                                  </table>
                                  {/*[if (gte mso 9)|(IE)]>
                </td>
                <td>
                  <![endif]*/}
                                  <table
                                    className="table-full"
                                    width={375}
                                    border={0}
                                    align="right"
                                    cellPadding={0}
                                    cellSpacing={0}
                                  >
                                    <tbody>
                                      <tr>
                                        <td height={90} />
                                      </tr>
                                      <tr>
                                        <td
                                          align="center"
                                          style={{
                                            border: "0 solid #fff",
                                            borderRadius: 4,
                                          }}
                                        >
                                          <table
                                            width="90%"
                                            border={0}
                                            align="center"
                                            cellPadding={0}
                                            cellSpacing={0}
                                          >
                                            <tbody>
                                              <tr>
                                                <td
                                                  valign="bottom"
                                                  style={{
                                                    fontFamily:
                                                      "Century gothic,arial,sans-serif",
                                                    fontSize: 24,
                                                    color: "#4a4a4a",
                                                    fontWeight: 100,
                                                    lineHeight: "30px",
                                                  }}
                                                >
                                                  From the CEO’s desk
                                                </td>
                                              </tr>
                                              <tr>
                                                <td height={10} />
                                              </tr>
                                              <tr>
                                                <td align="left">
                                                  <table
                                                    align="left"
                                                    width={30}
                                                    border={0}
                                                    cellSpacing={0}
                                                    cellPadding={0}
                                                  >
                                                    <tbody>
                                                      <tr>
                                                        <td
                                                          height={10}
                                                          style={{
                                                            borderBottom:
                                                              "3px solid red",
                                                          }}
                                                        />
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td height={20} />
                                              </tr>
                                            </tbody>
                                          </table>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                              <tr>
                                <td height={20} />
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={10} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "24px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              Dear Friends,
                                              <br />
                                              <br />
                                              It feels good to be back to business
                                              as usual and I hope your lives are
                                              also moving in a positive direction
                                              just like ours at Comsense. As we
                                              have crossed the second quarter of
                                              2022 and moved into the third, I am
                                              happy to see renewed energy,
                                              increased traction, better results
                                              and overall, a pulse of liveliness
                                              and positivity within the
                                              organization and around. Market is
                                              now open and business travels are
                                              back to the norm. And I must say,
                                              nothing beats the feel of meeting
                                              customers, team members, and
                                              vendors in person.
                                              <br />
                                              <br />
                                              Last quarter witnessed a lot of
                                              travel for us as we re-initiated our
                                              US and Singapore expansion plans.
                                              There is a lot of brainstorming and
                                              action been taken to make up for the
                                              lost time during COVID for these
                                              geographies. While we managed to
                                              retain and gain customers all
                                              through the past two and a half
                                              years, with improved market
                                              conditions now, we hope to see that
                                              growing exponentially.
                                              <br />
                                              <br />
                                              To make Comsense more employee
                                              friendly, we have initiated an
                                              Associate Delight Program which is
                                              being led by Sheetal, our HR head.
                                              As a part of this program, the
                                              leaders along with HR have created
                                              various interventions that improve
                                              and instill positive associate
                                              engagement. I wish great success to
                                              the entire team working relentlessly
                                              on this program.
                                              <br />
                                              <br />
                                              Our BU heads have now already
                                              started showcasing improved
                                              leadership skills based on our
                                              mentoring over last many months.
                                              Their hands-on training continues
                                              with Comsense Leadership as they
                                              keep displaying skills, taking
                                              ownership, and leading their
                                              individual packs.
                                              <br />
                                              <br />
                                              As for the financial updates, we
                                              have set for us aggressive targets
                                              for this financial year, and
                                              everyone is working hard to achieve
                                              the same. I am delighted to say
                                              that so far, we are on track with
                                              our internal plans, and everyone is
                                              striving hard to make it happen.
                                              <br />
                                              <br />
                                              Lastly, my personal focus remains
                                              high on our US and Singapore
                                              expansion plan as well on our
                                              ongoing Customer Delight Program. I
                                              will make every possible effort to
                                              ensure superior customer experience
                                              and Comsense’s global growth.
                                              <br />
                                              <br />
                                              With that I leave you to read about
                                              our achievements, success stories
                                              and our growing community of
                                              people. Happy Reading!
                                              <br />
                                              <br />
                                              <strong>Sagar Babar</strong>
                                              <br />
                                              <br />
                                              CEO &amp; Cofounder,
                                              <br />
                                              Comsense Technologies
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>
          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={10} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="title">
                                              Won Deals
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "16px",
                                                  color: "red",
                                                  lineHeight: "28px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                <strong>Govt. of Karnataka</strong>
                                                <br />
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              editable=""
                                              label="govt-karnataka-image"
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={Airoplan}
                                              alt="Govt. of Karnataka"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "16px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                Comsense was awarded a deal by the
                                                Govt. of Karnataka to create a
                                                dashboard for the Power and Energy
                                                Ministry of the state. As a part of
                                                our engagement, we will create a
                                                dashboard with a single view of
                                                KPI&apos;s across various parameters
                                                of the ministry.
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={30} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "16px",
                                                  color: "red",
                                                  lineHeight: "28px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                <strong>A Leading Software Company</strong>
                                                <br />
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              editable=""
                                              label="leading-software-company-image"
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={Graph}
                                              alt="A Leading Software Company"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="leading-software-company-body">
                                              A leading software and services company in
                                              India has engaged Comsense to support their
                                              UK client with their End-to- End Campaigns.
                                            </multiline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td height={30} />
                                        </tr>

                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "16px",
                                                  color: "red",
                                                  lineHeight: "28px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                <strong>
                                                  KleanMail is Winning Hearts Across the
                                                  Globe
                                                </strong>
                                                <br />
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              editable=""
                                              label="kleanmail-image"
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={Bank}
                                              alt="KleanMail"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="kleanmail-body">
                                              Our flagship product KleanMail was
                                              officially launched in the previous quarter
                                              and is witnessing great success in such a
                                              short span of time. KleanMail is an
                                              AI-Driven Email Validation Tool that cleans
                                              any email list with minimum 98% accuracy.
                                              It dramatically improves the efficiency of
                                              email campaigns, reduces hard and soft
                                              bounces, and enhances the IP reputation of
                                              the sender.
                                              <br />
                                              <br />
                                              KleanMail was recently chosen and bought as
                                              a preferred validation tool by:
                                              <br />
                                              - A US based company offering cold email as
                                              a service
                                              <br />
                                              - An innovative start-up that offers
                                              integrated platform for healthcare
                                              wearables and sensors
                                              <br />
                                              - A start-up studio working on consumer and
                                              enterprise products
                                            </multiline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td height={35} />
                                        </tr>

                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="testimonials-title">
                                              Testimonials
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              className="table-full"
                                              width="100%"
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    valign="top"
                                                    width="48%"
                                                    style={{
                                                      fontFamily:
                                                        "Open sans,arial,sans-serif",
                                                      fontSize: 14,
                                                      color: "#9b9b9b",
                                                      lineHeight: "24px",
                                                      textAlign: "left",
                                                    }}
                                                  >
                                                    <multiline label="testimonial-umesh">
                                                      &ldquo;Comsense team has done a
                                                      great job in setting up our data
                                                      streaming pipeline, segmentation
                                                      &amp; creating cohorts for various
                                                      campaigns. With this framework in
                                                      place, we are now confident of
                                                      scaling up rapidly.&rdquo;
                                                      <br />
                                                      <br />
                                                      <strong style={{ color: "#000" }}>
                                                        - Umesh Rai,
                                                      </strong>
                                                      <br />
                                                      VP Marketing (Digital &amp; Retail)
                                                      at Metropolis Healthcare
                                                    </multiline>
                                                  </td>
                                                  <td width="4%">&nbsp;</td>
                                                  <td
                                                    valign="top"
                                                    width="48%"
                                                    style={{
                                                      fontFamily:
                                                        "Open sans,arial,sans-serif",
                                                      fontSize: 14,
                                                      color: "#9b9b9b",
                                                      lineHeight: "24px",
                                                      textAlign: "left",
                                                    }}
                                                  >
                                                    <multiline label="testimonial-malikah">
                                                      &ldquo;The Comsense Team has been
                                                      an intricate part of the amazing
                                                      growth Reebok SA has seen in CRM.
                                                      The team has a wealth of knowledge
                                                      in the field and has been great in
                                                      collaborating with our e-com and
                                                      creative agencies&rdquo;
                                                      <br />
                                                      <br />
                                                      <strong style={{ color: "#000" }}>
                                                        - Malikah McDavis
                                                      </strong>
                                                      <br />
                                                      CRM &amp; ECOM Marketing Manager,
                                                      Reebok South Africa
                                                    </multiline>
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            style={{ border: "1px solid #d2d2d2" }}
                                            align="center"
                                          >
                                            <table
                                              className="table-inner"
                                              width={500}
                                              border={0}
                                              align="center"
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td height={18} />
                                                </tr>
                                                <tr>
                                                  <td
                                                    align="left"
                                                    style={{
                                                      fontFamily:
                                                        "Open sans,arial,sans-serif",
                                                      fontSize: 14,
                                                      color: "#9b9b9b",
                                                      lineHeight: "22px",
                                                    }}
                                                  >
                                                    <multiline label="testimonial-quote">
                                                      &ldquo;Risk-taking is the
                                                      cornerstone of empires&rdquo;
                                                      <br />
                                                      <strong style={{ color: "#000" }}>
                                                        - Est&eacute;e Lauder,
                                                      </strong>{" "}
                                                      Businesswoman and co-founder of
                                                      Est&eacute;e Lauder
                                                    </multiline>
                                                  </td>
                                                  <td
                                                    width={120}
                                                    align="right"
                                                    style={{ lineHeight: 0 }}
                                                  >
                                                    <img
                                                      src={BusinessQuoteOne}
                                                      alt="quote"
                                                      width={90}
                                                      style={{
                                                        display: "block",
                                                        lineHeight: 0,
                                                        fontSize: 0,
                                                        border: 0,
                                                      }}
                                                    />
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td height={18} />
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={30} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              paddingTop: 10,
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="events-title">
                                              Events
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>

                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 16,
                                              color: "red",
                                              lineHeight: "24px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Comsense hosted a round table discussion
                                            with leaders from IBM and TechData
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              editable=""
                                              label="events-roundtable-image"
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={Wonder5}
                                              alt="Round table discussion"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="left"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="events-roundtable-body">
                                              Comsense hosted a round table discussion in
                                              association with IBM and TechData bringing
                                              together Leaders from AI, Data, Marketing,
                                              and Analytics functions across multiple
                                              industries. These leaders shared their
                                              challenges and successes in the various
                                              stages of their digital transformation
                                              journey from building a Single View of
                                              Customer to implementing a Customer Data
                                              Platform to deploying real-time use cases
                                              to finally delivering an unparalleled
                                              Customer Experience.
                                            </multiline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td height={35} />
                                        </tr>

                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 16,
                                              color: "red",
                                              lineHeight: "24px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Sagar shares his phenomenal story
                                            <br />
                                            of rags to riches on Josh Talks
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              editable=""
                                              label="events-joshtalks-image"
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={Wonder6}
                                              alt="Josh Talks"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="left"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="events-joshtalks-body">
                                              Our CEO, Sagar Babar, gave a Josh Talk in
                                              May where he shared his life story and gave
                                              exciting insights into how he embraced
                                              failures to become successful. He spoke
                                              about his early years, his multi-industry
                                              stints, multiple businesses that he
                                              started, the failed startups and the
                                              success of Comsense. Sharing his success
                                              mantra, he said that he never shies away
                                              from asking help, nor does he get scared
                                              or embarrassed when seeking assistance. He
                                              also takes every opportunity to help the
                                              needy. Hear the fascinating story right
                                              from the horse’s mouth here.
                                            </multiline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td height={40} />
                                        </tr>

                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="news-title">
                                              News
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>

                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 16,
                                              color: "red",
                                              lineHeight: "24px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Comsense BU heads awarded ESOPs
                                            <br />
                                            on our 7th Foundation Day
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              editable=""
                                              label="news-esops-image"
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={Wonder7}
                                              alt="ESOPs"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="left"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="news-esops-body">
                                              On our 7th foundation day, our Cofounders
                                              Sagar, Vineet, Sushil &amp; Aniket handed
                                              ESOPs to our amazing BU heads. It was a
                                              token of appreciation for their loyalty,
                                              dedication, hard work, and trust in us
                                              throughout our journey. They have been an
                                              integral part of the growth journey of
                                              Comsense, and we wish them much luck on
                                              their way forward in taking Comsense to new
                                              heights.
                                            </multiline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td height={35} />
                                        </tr>

                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 16,
                                              color: "red",
                                              lineHeight: "24px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Comsense opens a new office in Atlanta, USA
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              editable=""
                                              label="news-atlanta-image"
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={Airoplan}
                                              alt="Atlanta office"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="left"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="news-atlanta-body">
                                              In line with our growth plans for this year
                                              and to achieve our mission 2024, we opened
                                              a new office in Atlanta, USA. The office
                                              was inaugurated by our CEO, Sagar Babar.
                                              With this new office in place, Comsense
                                              aims to expand its operation in US which is
                                              a key target geography for this year.
                                            </multiline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td height={35} />
                                        </tr>

                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 16,
                                              color: "red",
                                              lineHeight: "24px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Cold Email Masterclass
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              editable=""
                                              label="news-cold-email-image"
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={Graph}
                                              alt="Cold Email Masterclass"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="left"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="news-cold-email-body">
                                              Comsense&apos;s co-founder Biju Nambiar
                                              conducted a Cold Email Masterclass with
                                              renowned Growth Hacker and author of Growth
                                              Hacking Book Series, Rohan Chaubey
                                              <br />
                                              <br />
                                              Post the official launch of KleanMail, the
                                              AI- Driven Email Validation Tool from
                                              Comsense, the team organized a massively
                                              hit webinar in the last week of June 2022.
                                              The webinar titled &ldquo;The Cold Email
                                              Masterclass&rdquo; was jointly presented by
                                              our co-founder Biju Nambiar and Rohan
                                              Chaubey, a renowned growth marketer and
                                              co-founder of International Growth Hacking
                                              Day.
                                              <br />
                                              <br />
                                              The key take-aways of the webinar included:
                                              <br />
                                              - Strategies for cold email marketing
                                              <br />
                                              - Understanding the importance of building
                                              email list
                                              <br />
                                              - Understanding the importance of email
                                              verification
                                              <br />
                                              - Transformation strategies to efficiently
                                              increase customer engagement
                                              <br />
                                              <br />
                                              The webinar was a huge success with
                                              participants from across the globe.

                                              You can see the webinar recordings here.
                                              <br />
                                              <a
                                                href="https://www.youtube.com/watch?v=3VWQ_O-4xpk&t=30s"
                                                target="_blank"
                                                rel="noreferrer"
                                                style={{
                                                  color: "red",
                                                  textDecoration: "none",
                                                  fontWeight: 700,
                                                }}
                                              >
                                                here
                                              </a>
                                              <br />

                                            </multiline>
                                            <tr>
                                              <td height={25} />
                                            </tr>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>
          <layout label="quote">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      className="table-full"
                      width={600}
                      style={{ maxWidth: 600 }}
                      border={0}
                      align="center"
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td bgcolor="#FFFFFF" align="center">
                            <table
                              className="table-inner"
                              width={550}
                              style={{ maxWidth: 550 }}
                              border={0}
                              align="center"
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>


                                <tr>
                                  <td
                                    width={580}
                                    align="center"
                                    style={{
                                      fontFamily:
                                        "Open sans,arial,sans-serif",
                                      fontSize: 18,
                                      color: "red",
                                      lineHeight: "28px",
                                      fontWeight: 700,
                                      textAlign: "center",
                                      paddingTop: 20,
                                    }}
                                  >
                                    KleanMail ranked #4 Product of the Day on
                                    Product Hunt
                                  </td>
                                </tr>
                                <tr>
                                  <td height={20} />
                                </tr>
                                <tr>
                                  <td
                                    width={580}
                                    align="center"
                                    style={{ lineHeight: 0 }}
                                  >
                                    <img
                                      editable=""
                                      label="product-hunt-image"
                                      style={{
                                        display: "block",
                                        lineHeight: 0,
                                        fontSize: 0,
                                        border: 0,
                                        width: "100%",
                                      }}
                                      src={News3}
                                      alt="Product Hunt"
                                      width="100%"
                                      height="auto"
                                    />
                                  </td>
                                </tr>
                                <tr>
                                  <td height={25} />
                                </tr>
                                <tr>
                                  <td
                                    align="left"
                                    style={{
                                      fontFamily:
                                        "Open sans,arial,sans-serif",
                                      fontSize: 14,
                                      color: "#9b9b9b",
                                      lineHeight: "28px",
                                      textAlign: "justify",
                                    }}
                                  >
                                    <multiline label="product-hunt-body">
                                      KleanMail, our flagship product for
                                      Real-time Email Validation, was formally
                                      launched on Product Hunt in June 2022. In
                                      less than 24 hours, it was ranked #4
                                      product of the day by a process of voting
                                      done by Product Hunt users. We are super
                                      thrilled to have made it on the top list
                                      and hope KleanMail sees the growth that we
                                      anticipate.
                                    </multiline>
                                  </td>
                                </tr>

                                <tr>
                                  <td height={35} />
                                </tr>

                                <tr>
                                  <td
                                    align="center"
                                    style={{
                                      fontFamily:
                                        "Century gothic,arial,sans-serif",
                                      fontSize: 24,
                                      color: "#4a4a4a",
                                      fontWeight: 100,
                                      lineHeight: "30px",
                                    }}
                                  >
                                    <singleline label="success-stories-title">
                                      Success Stories
                                    </singleline>
                                  </td>
                                </tr>
                                <tr>
                                  <td height={20} />
                                </tr>
                                <tr>
                                  <td align="center">
                                    <table
                                      width={40}
                                      bgcolor="#FF0000"
                                      style={{ borderRadius: 10 }}
                                      border={0}
                                      cellPadding={0}
                                      cellSpacing={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td
                                            height={5}
                                            style={{
                                              lineHeight: 0,
                                              fontSize: 0,
                                            }}
                                          >
                                            &nbsp;
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                                <tr>
                                  <td height={25} />
                                </tr>
                                <tr>
                                  <td align="center">
                                    <table
                                      className="table-full"
                                      width="100%"
                                      border={0}
                                      cellPadding={0}
                                      cellSpacing={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td
                                            width="72%"
                                            valign="top"
                                            style={{
                                              border: "1px solid #d2d2d2",
                                              padding: 14,
                                            }}
                                          >
                                            <table
                                              width="100%"
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    style={{
                                                      fontFamily:
                                                        "Open sans,arial,sans-serif",
                                                      fontSize: 13,
                                                      color: "#4a4a4a",
                                                      lineHeight: "18px",
                                                      fontWeight: 700,
                                                    }}
                                                  >
                                                    A Leading Beauty and Skin Care
                                                    Solution Provider improves
                                                    revenues by more than 23% in
                                                    less than 6 months by creating
                                                    Single View of Customer
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td height={10} />
                                                </tr>
                                                <tr>
                                                  <td
                                                    style={{
                                                      fontFamily:
                                                        "Open sans,arial,sans-serif",
                                                      fontSize: 12,
                                                      fontWeight: 700,
                                                    }}
                                                  >
                                                    <a
                                                      href="https://www.comsensetechnologies.com/"
                                                      style={{
                                                        color: "red",
                                                        textDecoration: "none",
                                                        whiteSpace: "nowrap",
                                                      }}
                                                    >
                                                      Read more ›
                                                    </a>
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                          <td width={20}>&nbsp;</td>
                                          <td
                                            width="120"
                                            valign="middle"
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              editable=""
                                              label="success-story-icon-1"
                                              src={Andy}
                                              alt=""
                                              width={120}
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: 120,
                                                height: "auto",
                                                maxWidth: 120,
                                              }}
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td colSpan={3} height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width="72%"
                                            valign="top"
                                            style={{
                                              border: "1px solid #d2d2d2",
                                              padding: 14,
                                            }}
                                          >
                                            <table
                                              width="100%"
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    style={{
                                                      fontFamily:
                                                        "Open sans,arial,sans-serif",
                                                      fontSize: 13,
                                                      color: "#4a4a4a",
                                                      lineHeight: "18px",
                                                      fontWeight: 700,
                                                      textAlign: "left",
                                                    }}
                                                  >
                                                    Largest Retail Group in New
                                                    Zealand Improves Sales in Less
                                                    Than 3 Months by Using
                                                    Predictive Analytics
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td height={10} />
                                                </tr>
                                                <tr>
                                                  <td
                                                    style={{
                                                      fontFamily:
                                                        "Open sans,arial,sans-serif",
                                                      fontSize: 12,
                                                      fontWeight: 700,
                                                    }}
                                                  >
                                                    <a
                                                      href="/success-stories/data-science-to-step-up-the-retail-game-for-the-largest-retail-brand-in-new-zealand-specialized-in-outdoor-and-adventure-sports-equipment"
                                                      style={{
                                                        color: "red",
                                                        textDecoration: "none",
                                                        whiteSpace: "nowrap",
                                                      }}
                                                    >
                                                      Read more ›
                                                    </a>
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                          <td width={20}>&nbsp;</td>
                                          <td
                                            width="120"
                                            valign="middle"
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              editable=""
                                              label="success-story-icon-2"
                                              src={BusinessQuoteOne}
                                              alt=""
                                              width={120}
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: 120,
                                                height: "auto",
                                                maxWidth: 120,
                                              }}
                                            />
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>

                                <tr>
                                  <td height={35} />
                                </tr>

                                <tr>
                                  <td align="center">
                                    <table
                                      width="100%"
                                      border={0}
                                      cellPadding={0}
                                      cellSpacing={0}
                                      style={{
                                        border: "2px solid #ff0000",
                                      }}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "#ff0000",
                                              fontWeight: 800,
                                              letterSpacing: 0.5,
                                            }}
                                          >
                                            OFFER OF THE DAY !!!
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={10} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#4a4a4a",
                                            }}
                                          >
                                            Limited Time Deal of Kleanmail
                                            <br />
                                            One Time Purchase of
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={8} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "#4a4a4a",
                                              fontWeight: 800,
                                            }}
                                          >
                                            <span
                                              style={{
                                                textDecoration: "line-through",
                                                color: "#ff0000",
                                              }}
                                            >
                                              $1600
                                            </span>{" "}
                                            <span style={{ color: "#ff0000" }}>
                                              $99
                                            </span>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={10} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 13,
                                              color: "#4a4a4a",
                                              lineHeight: "22px",
                                            }}
                                          >
                                            ✓ 0.5 Million verification credits
                                            <br />
                                            ✓ Instant or Quick Verification
                                            <br />
                                            ✓ Bulk Verification
                                            <br />
                                            ✓ Lifetime Validity
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={14} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 20,
                                              color: "#4a4a4a",
                                              fontWeight: 800,
                                            }}
                                          >
                                            KMC202299
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 12,
                                              color: "#9b9b9b",
                                            }}
                                          >
                                            Use this code to avail offer
                                            <br />
                                            <br />
                                            Offer Valid for Limited Time!
                                            <br />
                                            Grab Yours Before It&apos;s Gone!
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={15} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="left"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 12,
                                              color: "#4a4a4a",
                                              lineHeight: "20px",
                                              paddingLeft: 16,
                                              paddingRight: 16,
                                            }}
                                          >
                                            To avail the offer, all you need to do
                                            is to follow these simple steps:
                                            <br />
                                            <br />
                                            1. Go to:{" "}
                                            <a
                                              href="https://kleanmail.com/"
                                              target="_blank"
                                              rel="noreferrer"
                                              style={{
                                                color: "red",
                                                textDecoration: "none",
                                              }}
                                            >
                                              https://kleanmail.com/
                                            </a>
                                            <br />
                                            2. Click on &apos;Register&apos; buttton.
                                            <br />
                                            3. Select &apos;Signup&apos; option.
                                            <br />
                                            4. Register yourself by adding
                                            &apos;Company Name&apos;,
                                            &apos;Contact Number&apos;,
                                            &apos;Email ID&apos;
                                            <br />
                                            5. Use Verification Code to complete
                                            the Registration process.
                                            <br />
                                            6. Post successful Registration, you
                                            can sign in with your credentials.
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={18} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>

                                <tr>
                                  <td height={25} />
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>
          {/*  */}
          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <br />
                                    <br />
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="title">
                                              Comsense Employee Engagement
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              editable=""
                                              label="employee-engagement-image"
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={Impact}
                                              alt="Comsense Employee Engagement"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="left"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="employee-engagement-body">
                                              We value every member of Comsense Community
                                              – be it customers, associates, or vendors.
                                              Just like our Customer Delight Program, we
                                              take our Associate Delight Program quite
                                              seriously. Through our Associate Delight
                                              Program, we relentlessly try to engage the
                                              team positively and constructively. The
                                              program includes various areas of focus
                                              with the top ones being Career Planning,
                                              Technical Trainings (UpSkilling and
                                              Cross-Skilling), Soft Skill Trainings,
                                              Sports Days, Wellness Programs, Workforce
                                              Culture Enablement, Associate Empowerment,
                                              and Rewards and Recognitions. The previous
                                              quarter saw many activities conducted around
                                              these aspects of associate engagement. We
                                              are already witnessing the positive results
                                              of many such interventions.
                                            </multiline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td height={35} />
                                        </tr>

                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="welcome-aboard-title">
                                              Welcome Aboard
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              editable=""
                                              label="welcome-aboard-image"
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={Welcome}
                                              alt="Welcome Aboard"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="left"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="welcome-aboard-body">
                                              Just like previous quarters, Comsense Team
                                              is growing. This quarter we welcome Rohit
                                              Londhe, Shraddha Kale, Ashwini Ghorpade,
                                              Saif Makandar, Anant Kadam, Shivkumar
                                              Dusad, Yash Badani, Neha Jagadale, Kota
                                              Hema Nag, Pravish Ranjan, Dipali More,
                                              Sharayu Tambe, Pradnya Malekar, Rakhi
                                              Ankar, and Savita Kandharkar to the
                                              Comsense family. We wish them luck in
                                              their journey here.
                                            </multiline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td height={35} />
                                        </tr>

                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="awards-title">
                                              Awards
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Comsense Quarterly Awards
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              editable=""
                                              label="awards-image"
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={EmployeeAwards1}
                                              alt="Comsense Quarterly Awards"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="left"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="awards-intro">
                                              Quarterly Awards are awaited with great
                                              enthusiasm at Comsense. It is our way to
                                              appreciate and thank our team for their
                                              invaluable contribution to Comsense&rsquo;s
                                              growth. Our performers, specially the
                                              younger and fresher ones, find them highly
                                              motivating and strive hard to get one. This
                                              quarter witnessed some great contributions
                                              that were aptly awarded.
                                              <br />
                                              <br />
                                              Our winner list included:
                                            </multiline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td height={20} />
                                        </tr>

                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 16,
                                              color: "red",
                                              lineHeight: "24px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Rookie (Rising Star) Award
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={10} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="left"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="awards-rookie">
                                              a) <strong>Akanksha Jadhav</strong>
                                              <br />
                                              A quick learner who takes sincere efforts
                                              to deliver good quality work, Akanksha is
                                              our true rising star.
                                              <br />
                                              <br />
                                              b) <strong>Ranjith Rajmohan</strong>
                                              <br />
                                              Ranjith believes in quality of work. He
                                              developed a robust accelerator with
                                              best-in-class and up-to-date ML algorithm
                                              which made him a true contender for our
                                              Rookie Award.
                                              <br />
                                              <br />
                                              c) <strong>Prajakta Mohite</strong>
                                              <br />
                                              Aptly rewarded for taking lead in
                                              challenging circumstances, Prajakta
                                              displays relentless dedication towards her
                                              work. She sure is a fresh shining star at
                                              Comsense.
                                              <br />
                                              <br />
                                              d) <strong>Rohit Londhe</strong>
                                              <br />
                                              Rohit displays great work ethics and shows
                                              immense dedication to his work which made
                                              him a great candidate for the Rookie
                                              Awards. He has great attitude for timely
                                              closure of projects.
                                              <br />
                                              <br />
                                              e) <strong>Sheetal Rao</strong>
                                              <br />
                                              In a short span of time, Sheetal has made
                                              exemplary contribution towards Comsense&rsquo;s
                                              growth and processes for which she rightly
                                              deserved this award.
                                            </multiline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td height={25} />
                                        </tr>

                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 16,
                                              color: "red",
                                              lineHeight: "24px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Star Performer Award
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={10} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="left"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="awards-star">
                                              a) <strong>Avneesh Naha</strong>
                                              <br />
                                              An extremely dedicated professional,
                                              Avneesh has great passion for the work he
                                              undertakes. He is proactive, creative,
                                              accountable and brings his best to very
                                              project. No wonder he made his place right
                                              at the top as our Star Performer for the
                                              quarter.
                                            </multiline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td height={25} />
                                        </tr>

                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 16,
                                              color: "red",
                                              lineHeight: "24px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Customer Delight Award
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={10} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="left"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="awards-customer-delight">
                                              a) <strong>Pooja Kushwaha</strong>
                                              <br />
                                              Pooja&rsquo;s proactivity, approach to
                                              problems and solutioning are unmatched. Her
                                              sharp customer focus, made her win the very
                                              coveted Customer Delight Award
                                            </multiline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td height={25} />
                                        </tr>

                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 16,
                                              color: "red",
                                              lineHeight: "24px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Team Player Award
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={10} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="left"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="awards-team-player">
                                              a) <strong>Tushar Valkunde</strong>
                                              <br />
                                              Tushar is a quick learner and takes sincere
                                              effort in delivering quality work. He is a
                                              great team player.
                                              <br />
                                              <br />
                                              b) <strong>Prajakta Patil</strong>
                                              <br />
                                              Team spirit defines Prajakta. She knows
                                              when to step up and how to be a great team
                                              player. She intently looks forward to the
                                              success of the team and thus was rewarded
                                              as a great Team player.
                                              <br />
                                              <br />
                                              c) <strong>Hussain Mahadik</strong>
                                              <br />
                                              Hussain displays willingness to provide
                                              support to others and believes in positive
                                              collaboration. His contributions as a team
                                              member have brought in many positive
                                              outcomes for which he was rightly awarded
                                              the Team Player Award.
                                            </multiline>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>
          {/* Tech Delivery Newsletter + News */}
          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={10} />
                                        </tr>
                                        <tr>
                                          <td height={10} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>
          {/* Events & Celebrations */}
          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={30} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Administrative Excellence Award
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="left"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="admin-excellence-body">
                                              a) <strong>Vrushali Paralkar</strong>
                                              <br />
                                              Vrushali&rsquo;s energy and enthusiasm
                                              for getting the job done is
                                              unparalleled. She is dedicated, swift
                                              in her approach and highly positive in
                                              her approach towards all work that is
                                              pushed at her. The smile and grace
                                              with which she achieves her tasks and
                                              beyond, make her a deserving candidate
                                              for Administrative Excellence Award.
                                              <br />
                                              <br />
                                              b) <strong>Sushama Chikalkar</strong>
                                              <br />
                                              Sushama&rsquo;s dedication and sincerity
                                              define her very character. In her long
                                              association with Comsense, she has
                                              contributed in more than one way to
                                              keep us going. She always bears the best
                                              interest of the organizations in her
                                              mind. Her discipline keeps us on the
                                              right track. She truly deserves this
                                              award.
                                              <br />
                                              <br />
                                              We send out heartiest congratulations
                                              to all the winners and wish them much
                                              more success in the coming quarters.
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              editable=""
                                              label="interns-collage-image"
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={EmployeeAwards2}
                                              alt="Interns"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="left"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="interns-intro">
                                              As a twist to the tale, this time we
                                              have some interns from IIM Indore who
                                              had a short stint with us sharing their
                                              experience about Comsense. Hear what
                                              they have to say about their exposure,
                                              learning and the kind of mentorship
                                              they got with us.
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={15} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              className="table-full"
                                              width="100%"
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td width="30%" align="center">
                                                    <a
                                                      href="https://www.youtube.com/watch?v=zGRq5GkHoQg"
                                                      style={{
                                                        color: "red",
                                                        textDecoration: "none",
                                                        fontFamily:
                                                          "Open sans,arial,sans-serif",
                                                        fontSize: 12,
                                                        fontWeight: 700,
                                                      }}
                                                    >
                                                      View Video
                                                    </a>
                                                    <br />
                                                    <img
                                                      editable=""
                                                      label="intern-deepak-image"
                                                      src={Testimonial1}
                                                      alt="Deepak Pugaonkar"
                                                      width={90}
                                                      style={{
                                                        display: "block",
                                                        margin: "10px auto 0",
                                                        lineHeight: 0,
                                                        fontSize: 0,
                                                        border: 0,
                                                      }}
                                                    />
                                                    <div
                                                      style={{
                                                        fontFamily:
                                                          "Open sans,arial,sans-serif",
                                                        fontSize: 12,
                                                        color: "#4a4a4a",
                                                        fontWeight: 700,
                                                        marginTop: 8,
                                                      }}
                                                    >
                                                      Deepak Pugaonkar
                                                    </div>
                                                    <div
                                                      style={{
                                                        fontFamily:
                                                          "Open sans,arial,sans-serif",
                                                        fontSize: 11,
                                                        color: "#9b9b9b",
                                                        marginTop: 2,
                                                      }}
                                                    >
                                                      IIM Indore &lsquo;23
                                                    </div>
                                                  </td>
                                                  <td width="5%">&nbsp;</td>
                                                  <td width="30%" align="center">
                                                    <a
                                                      href="https://www.youtube.com/watch?v=e_qjLkVsvO0&t=96s"
                                                      style={{
                                                        color: "red",
                                                        textDecoration: "none",
                                                        fontFamily:
                                                          "Open sans,arial,sans-serif",
                                                        fontSize: 12,
                                                        fontWeight: 700,
                                                      }}
                                                    >
                                                      View Video
                                                    </a>
                                                    <br />
                                                    <img
                                                      editable=""
                                                      label="intern-harshal-image"
                                                      src={Testimonial2}
                                                      alt="Harshal Thakur"
                                                      width={90}
                                                      style={{
                                                        display: "block",
                                                        margin: "10px auto 0",
                                                        lineHeight: 0,
                                                        fontSize: 0,
                                                        border: 0,
                                                      }}
                                                    />
                                                    <div
                                                      style={{
                                                        fontFamily:
                                                          "Open sans,arial,sans-serif",
                                                        fontSize: 12,
                                                        color: "#4a4a4a",
                                                        fontWeight: 700,
                                                        marginTop: 8,
                                                      }}
                                                    >
                                                      Harshal Thakur
                                                    </div>
                                                    <div
                                                      style={{
                                                        fontFamily:
                                                          "Open sans,arial,sans-serif",
                                                        fontSize: 11,
                                                        color: "#9b9b9b",
                                                        marginTop: 2,
                                                      }}
                                                    >
                                                      IIM Indore &lsquo;23
                                                    </div>
                                                  </td>
                                                  <td width="5%">&nbsp;</td>
                                                  <td width="30%" align="center">
                                                    <a
                                                      href="https://www.youtube.com/watch?v=jYdVev6kfXk"
                                                      style={{
                                                        color: "red",
                                                        textDecoration: "none",
                                                        fontFamily:
                                                          "Open sans,arial,sans-serif",
                                                        fontSize: 12,
                                                        fontWeight: 700,
                                                      }}
                                                    >
                                                      View Video
                                                    </a>
                                                    <br />
                                                    <img
                                                      editable=""
                                                      label="intern-mayank-image"
                                                      src={BusinessQuoteOne}
                                                      alt="Mayank Patel"
                                                      width={90}
                                                      style={{
                                                        display: "block",
                                                        margin: "10px auto 0",
                                                        lineHeight: 0,
                                                        fontSize: 0,
                                                        border: 0,
                                                      }}
                                                    />
                                                    <div
                                                      style={{
                                                        fontFamily:
                                                          "Open sans,arial,sans-serif",
                                                        fontSize: 12,
                                                        color: "#4a4a4a",
                                                        fontWeight: 700,
                                                        marginTop: 8,
                                                      }}
                                                    >
                                                      Mayank Patel
                                                    </div>
                                                    <div
                                                      style={{
                                                        fontFamily:
                                                          "Open sans,arial,sans-serif",
                                                        fontSize: 11,
                                                        color: "#9b9b9b",
                                                        marginTop: 2,
                                                      }}
                                                    >
                                                      IIM Indore &lsquo;23
                                                    </div>
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td height={40} />
                                        </tr>

                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="life-at-comsense-title">
                                              Life at Comsense
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="left"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="life-at-comsense-intro">
                                              All work and no play makes Jack a dull boy
                                              and we never encourage such Jacks at
                                              Comsense. After all, what&rsquo;s life
                                              without the fun!
                                            </multiline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td height={25} />
                                        </tr>

                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Birthday Celebrations
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              editable=""
                                              label="birthday-celebrations-image"
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={Birthday1}
                                              alt="Birthday Celebrations"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="left"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="birthday-celebrations-body">
                                              In the last quarter we celebrated the
                                              Birthdays of our team members Anant Kadam,
                                              Sumedh Pawaskar, Tushar Valkunde, Rutika
                                              Bhikule, Varada Pol, Pravish Rajan, Pranay
                                              Pimple, Shriya Sharma, Karan Mudliar, Saurav
                                              Patil. As always, the celebrations included
                                              cake cutting, snack party, chitter chatter
                                              and loads of laughter.
                                            </multiline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td height={25} />
                                        </tr>

                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Comsense Premier League
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              editable=""
                                              label="cpl-image"
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={Birthday2}
                                              alt="Comsense Premier League"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="left"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="cpl-body">
                                              The Comsense Premiere League was organized
                                              last month with our super enthusiastic
                                              cricket lovers in the house. The BlackBulls
                                              were crowned the champions and took the
                                              trophy home wining a nail biting final
                                              against the BlueBeetles. The event has
                                              truly been a testament that there&apos;s
                                              nothing like the intoxicating spirit of
                                              Comsense Team&apos;s sportsmanship! All the
                                              players demonstrated terrific performances,
                                              while still trying hard enough not just to
                                              win themselves personal achievements or
                                              titles&mdash;all were in pursuit of
                                              success!
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>
          {/* Comsense Leadership Meets Netcore CEO North America */}
          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <br />
                                    /tbody&gt;
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            CSR Activity
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={15} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              editable=""
                                              label="csr-activity-image"
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={Impact}
                                              alt="CSR Activity"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="csr-activity-body">
                                              As always CSR activities remain at
                                              the core of our operating principles.
                                              Giving back to the society drives us
                                              in the right directions. As a part
                                              of our CSR initiatives, we tripled
                                              our contribution to Dnyanankur school
                                              in the past quarter. The school
                                              provides education to the needy
                                              children who otherwise might be forced
                                              to drop out of school. We hope our
                                              little contribution makes a difference
                                              in the life of these children and the
                                              future of our country.
                                            </multiline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td height={45} />
                                        </tr>

                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            Spiritual Corner
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={15} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              editable=""
                                              label="spiritual-corner-image"
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={Motivation}
                                              alt="Spiritual Corner"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="spiritual-corner-body">
                                              For more information please visit:&nbsp;
                                              <a
                                                href="https://heartfulness.org/in-en/"
                                                target="_blank"
                                                rel="noreferrer"
                                                style={{
                                                  color: "red",
                                                  textDecoration: "none",
                                                }}
                                              >
                                                Heartfulness: Meditation
                                              </a>
                                              &nbsp;|&nbsp;
                                              <a
                                                href="https://heartfulness.org/in-en/"
                                                target="_blank"
                                                rel="noreferrer"
                                                style={{
                                                  color: "red",
                                                  textDecoration: "none",
                                                }}
                                              >
                                                Relaxation
                                              </a>
                                              &nbsp;|&nbsp;
                                              <a
                                                href="https://heartfulness.org/in-en/"
                                                target="_blank"
                                                rel="noreferrer"
                                                style={{
                                                  color: "red",
                                                  textDecoration: "none",
                                                }}
                                              >
                                                Yoga
                                              </a>
                                              &nbsp;|&nbsp;
                                              <a
                                                href="https://heartfulness.org/in-en/"
                                                target="_blank"
                                                rel="noreferrer"
                                                style={{
                                                  color: "red",
                                                  textDecoration: "none",
                                                }}
                                              >
                                                Spirituality
                                              </a>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>
          <table
            className="full"
            bgcolor="#333742"
            align="center"
            width="100%"
            border={0}
            cellSpacing={0}
            cellPadding={0}
          >
            <tbody>
              <tr>
                <td align="center">
                  <table
                    className="table-full"
                    width={600}
                    style={{ maxWidth: 600 }}
                    border={0}
                    align="center"
                    cellPadding={0}
                    cellSpacing={0}
                  >
                    <tbody>
                      <tr>
                        <td
                          align="center"
                          background={Building}
                          bgcolor="#515663"
                          style={{
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                          }}
                        >
                          <table
                            align="center"
                            width="95%"
                            border={0}
                            cellSpacing={0}
                            cellPadding={0}
                          >
                            <tbody>
                              <tr>
                                <td height={20} />
                              </tr>
                              <tr>
                                <td
                                  align="center"
                                  style={{
                                    fontFamily:
                                      "Century gothic,arial,sans-serif",
                                    fontSize: 22,
                                    fontWeight: 600,
                                    lineHeight: "30px",
                                    color: "#fff",
                                    letterSpacing: 1,
                                  }}
                                >
                                  Thanks for reading.
                                  <br />
                                  <span
                                    style={{
                                      fontFamily:
                                        "Century gothic,arial,sans-serif",
                                      fontSize: 14,
                                      fontWeight: 400,
                                      color: "#fff",
                                      letterSpacing: 1,
                                    }}
                                  >
                                    Did someone share this with you?{" "}
                                    <a
                                      style={{ color: "#fff" }}
                                      href="https://www.comsenseconsulting.com/newsletter/subscribe.html"
                                      target="_blank" rel="noreferrer"
                                    >
                                      <u>Sign up</u>
                                    </a>{" "}
                                    here.
                                  </span>
                                </td>
                              </tr>
                              <tr>
                                <td height={15} />
                              </tr>
                              <tr>
                                <td align="center">
                                  <table
                                    align="center"
                                    border={0}
                                    cellSpacing={0}
                                    cellPadding={0}
                                  >
                                    <tbody>
                                      <tr>
                                        <td
                                          bgcolor="#FF0000"
                                          height={40}
                                          style={{
                                            fontFamily:
                                              "Century Gothic,sans-serif",
                                            fontSize: 14,
                                            color: "#4a4a4a",
                                            fontWeight: 700,
                                            paddingLeft: 15,
                                            paddingRight: 16,
                                            letterSpacing: "1.5px",
                                          }}
                                        >
                                          <a
                                            href="https://www.comsensetechnologies.com/newsletter/subscribe.html"
                                            style={{
                                              textDecoration: "none",
                                              color: "#fff",
                                              borderRadius: 5,
                                            }}
                                            target="_blank" rel="noreferrer"
                                          >
                                            SUBSCRIBE
                                          </a>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  style={{
                                    fontFamily:
                                      "Century gothic,arial,sans-serif",
                                    fontSize: 11,
                                    fontWeight: 400,
                                    color: "#fff",
                                    letterSpacing: 1,
                                    textAlign: "center",
                                  }}
                                >
                                  <br />
                                  If you liked this Newsletter, please recommend
                                  it to someone you know.
                                  <br />
                                  Or why not even share it on Twitter or
                                  Linkedin? … enough right?
                                  <br />
                                  If you don’t want to receive future
                                  Newsletters, please click here to{" "}
                                  <a
                                    style={{ color: "#fff" }}
                                    href="https://www.comsensetechnologies.com/newsletter/unsubscribe.html"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <u>unsubscribe</u>
                                  </a>
                                  .<br />
                                  We will miss you!
                                  <br />
                                  <br />
                                  {/* View April 2024 Newsletter Here <a style=color:#fff
                  href=https://comsensetechnologies.com/wp-content/newsletter/april-2024/
                  target=_blank><u>here</u></a>. */}
                                </td>
                              </tr>
                              <tr>
                                <td height={20} />
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </repeater>
        <table
          className="full"
          bgcolor="#333742"
          align="center"
          width="100%"
          border={0}
          cellSpacing={0}
          cellPadding={0}
        >
          <tbody>
            <tr>
              <td align="center">
                <table
                  className="table-full"
                  width={600}
                  style={{ maxWidth: 600 }}
                  border={0}
                  align="center"
                  cellPadding={0}
                  cellSpacing={0}
                >
                  <tbody>
                    <tr>
                      <td bgcolor="#FFFFFF" align="center">
                        <table
                          className="table-inner"
                          width={550}
                          style={{ maxWidth: 550 }}
                          border={0}
                          align="center"
                          cellPadding={0}
                          cellSpacing={0}
                        >
                          <tbody>
                            <tr>
                              <td height={25} />
                            </tr>
                            <tr>
                              <td
                                align="center"
                                style={{
                                  fontFamily: '"Open sans",Arial,sans-serif',
                                  color: "#4a4a4a",
                                  fontSize: 16,
                                }}
                              >
                                FOLLOW US
                              </td>
                            </tr>
                            <tr>
                              <td height={25} />
                            </tr>
                            <tr>
                              <td>
                                <table
                                  className="table-full"
                                  border={0}
                                  align="center"
                                  cellPadding={0}
                                  cellSpacing={0}
                                >
                                  <tbody>
                                    <tr>
                                      <td>
                                        <table
                                          border={0}
                                          align="center"
                                          cellPadding={0}
                                          cellSpacing={0}
                                        >
                                          <tbody>
                                            <tr>
                                              <td
                                                align="center"
                                                style={{ lineHeight: 0 }}
                                              >
                                                <a
                                                  href="https://www.facebook.com/Comsenseconsulting/"
                                                  target="_blank" rel="noreferrer"
                                                >
                                                  <img
                                                    src={fb1}
                                                    alt="img"
                                                    width={20}
                                                    style={{
                                                      display: "block",
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                      border: 0,
                                                    }}
                                                    editable=""
                                                    label="social-1"
                                                  />
                                                </a>
                                              </td>
                                              <td width={20} />
                                              <td
                                                align="center"
                                                style={{ lineHeight: 0 }}
                                                target="_blank"
                                              >
                                                <a href="https://twitter.com/ComsenseTech">
                                                  <img
                                                    src={tw1}
                                                    alt="img"
                                                    width={20}
                                                    style={{
                                                      display: "block",
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                      border: 0,
                                                    }}
                                                    editable=""
                                                    label="social-2"
                                                  />
                                                </a>
                                              </td>
                                              <td width={20} />
                                              <td
                                                align="center"
                                                style={{ lineHeight: 0 }}
                                              >
                                                <a
                                                  href="http://linkedin.com/company/comsense-consulting"
                                                  target="_blank" rel="noreferrer"
                                                >
                                                  <img
                                                    src={ln1}
                                                    alt="img"
                                                    width={20}
                                                    style={{
                                                      display: "block",
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                      border: 0,
                                                    }}
                                                    editable=""
                                                    label="social-3"
                                                  />
                                                </a>
                                              </td>
                                              <td width={20} />
                                              <td
                                                align="center"
                                                style={{ lineHeight: 0 }}
                                              >
                                                <a
                                                  href="https://www.instagram.com/comsensemktg/"
                                                  target="_blank" rel="noreferrer"
                                                >
                                                  <img
                                                    src={ig1}
                                                    alt="img"
                                                    width={20}
                                                    style={{
                                                      display: "block",
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                      border: 0,
                                                    }}
                                                    editable=""
                                                    label="social-4"
                                                  />
                                                </a>
                                              </td>
                                              <td width={20} />
                                              <td
                                                align="center"
                                                style={{ lineHeight: 0 }}
                                              >
                                                <a
                                                  href="https://www.youtube.com/channel/UCCekynsEDZS7VORzB5KwX9g"
                                                  target="_blank" rel="noreferrer"
                                                >
                                                  <img
                                                    src={yt1}
                                                    alt="img"
                                                    width={20}
                                                    style={{
                                                      display: "block",
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                      border: 0,
                                                    }}
                                                    editable=""
                                                    label="social-5"
                                                  />
                                                </a>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                            <tr>
                              <td height={25} />
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td height={5} bgcolor="#FF0000" />
                    </tr>
                  </tbody>
                </table>
                <table
                  className="table-full"
                  width={600}
                  style={{ maxWidth: 600 }}
                  border={0}
                  align="center"
                  cellPadding={0}
                  cellSpacing={0}
                >
                  <tbody>
                    <tr>
                      <td height={25} />
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </>
    </>
  );
};

export default August2022;
